import {
  SET_PRINCIPALS,
  SET_PRINCIPALS_ERROR,
  CLEAR_PRINCIPALS,
} from "../../constants/action-types";

const initState = {
  data: [],
};

export const principals = (state = initState, action) => {
  switch (action.type) {
    case SET_PRINCIPALS:
      return { ...state, data: action.payload };
    case SET_PRINCIPALS_ERROR:
      return { ...state, error: action.payload };
    case CLEAR_PRINCIPALS:
      return { ...state, data: [] };
    default:
      return state;
  }
};
